import GlobalLoadingService from "@/utils/globalLoading";
import MessageService from "@/utils/message";
import httpService from "@/utils/request";
import tokenService from "@/utils/tokenService";

const angelFundService = {
  // 创建
  createAngelFundOrg: (params: any) => {
    const url = "/workbench/angel-fund-org/createAngelFundOrg";
    return httpService.post(url, params);
  },
  // 删除
  deleteAngelFundOrg(id: any) {
      const url = "/workbench/angel-fund-org/deleteAngelFundOrg/"+id;
      return httpService.delete(url);
  },
  // 查询详情
  getAngelFundOrg(id: any) {
    const url = "/workbench/angel-fund-org/getAngelFundOrg/"+id;
    return httpService.get(url);
  },
  // 分页获取
  getAngelFundOrgPageListByParams: (params: any) => {
    const url = "/workbench/angel-fund-org/getAngelFundOrgPageListByParams";
    return httpService.post(url, params);
  },
  // 一次性获取
  getAngelFundOrgOptionDtoList: () => {
    const url = "/workbench/angel-fund-org/getAngelFundOrgOptionDtoList";
    return httpService.get(url);
  },
  // 根据基金类型一次性获取
  getAngelFundOrgOptionDtoListByType: (type:any) => {
    const url = `/workbench/angel-fund-org/getAngelFundOrgOptionDtoListByType/${type}`;
    return httpService.get(url);
  },
  // 更新
  updateAngelFundOrg: (params: any) => {
    const url = "/workbench/angel-fund-org/updateAngelFundOrg";
    return httpService.put(url, params);
  },
  // 修改状态
  updateAngelFundStatus: (params: any) => {
    const url = "/workbench/angel-fund-org/updateAngelFundStatus";
    return httpService.post(url, params);
  },
  
  // 获取模板
  getAngelFundOrgTemplateExcelFile:(params: any) => {
    const url = "/workbench/angel-fund-org/getAngelFundOrgTemplateExcelFile";
    return httpService.post(url, params, {responseType: "blob"});
  },
  // 导入excel
  uploadAndAnalysisExcelTemplate:(file:any, successCallback: (data:any) => void) => {
    GlobalLoadingService.openLoading();
    let uploadUrl = '/workbench/angel-fund-org/uploadAndAnalysisExcelTemplate';
    var formData = new FormData();
    formData.append('uploadFile', file);
    const serviceTicket = tokenService.getToken;
    let config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': serviceTicket
        },
        onUploadProgress:(progressEvent:any)=>{
            console.log("enterServiceUploadProgress-----------");
            if(progressEvent.loaded != progressEvent.total){
                const percentDone = Math.round(100 * progressEvent.loaded / progressEvent.total);
                return `${percentDone}%`;
            }
        }
    };
    httpService.post(uploadUrl,formData,config).then(
      (event:any) => {
          console.log(event);
          successCallback(event)
      },
      (err:any) => {
          console.log(err);
          MessageService.info('error', '提交失败');
      }).finally(()=>{
        GlobalLoadingService.closeLoading();
    });
  },
  // 导出excel
  getAngelFundOrgExcelFile:(params: any) => {
    return httpService.post('/workbench/angel-fund-org/getAngelFundOrgExcelFile', params, {responseType: "blob"});
  },
  // 大宽表导出
  getFundBasicInfoOutExcel:(params: any) =>{
    return httpService.post('/workbench/angel-fund-org/getFundBasicInfoOutExcel', params, {responseType: "blob"});
  },

  // 创建
  createAngelFundProject: (params: any) => {
    const url = "/workbench/angel-fund-project/createAngelFundProject";
    return httpService.post(url, params);
  },
  // 删除
  deleteAngelFundProject(id: any) {
      const url = "/workbench/angel-fund-project/deleteAngelFundProject/"+id;
      return httpService.delete(url);
  },
  // 查询详情
  getAngelFundProject(id: any) {
    const url = "/workbench/angel-fund-project/getAngelFundProject/"+id;
    return httpService.get(url);
  },
  // 分页获取
  getAngelFundProjectPageListByParams: (params: any) => {
    const url = "/workbench/angel-fund-project/getAngelFundProjectPageListByParams";
    return httpService.post(url, params);
  },
  // 更新
  updateAngelFundProject: (params: any) => {
    const url = "/workbench/angel-fund-project/updateAngelFundProject";
    return httpService.put(url, params);
  },


}

export default angelFundService;